import classNames from 'classnames';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import CustomShowMoreText from './CustomShowMoreText/CustomShowMoreText';
import './laneContainer.less';

function LaneContainer({
	majorHeader,
	description,
	extra,
	icon,
	style,
	backgroundClass,
	renderIcon,
	extraFooter,
	isMobile,
	children,
}) {
	const isMobileSize = isMobile();

	const getClassNames = () => {
		return classNames('lane-container', {
			[backgroundClass]: backgroundClass,
		});
	};

	const renderLaneFooterExtra = () => {
		return extraFooter && <div className="extra-footer">{extraFooter}</div>;
	};

	const renderLaneHeaders = () => {
		if (majorHeader) {
			return (
				<div className="lane-headers">
					<div className="lane-primary">
						<div>
							<div
								className={`${
									!isMobileSize
										? 'lane-primary-header'
										: 'lane-primary-header-mobile'
								}`}>
								{getLanePrimaryHeader(majorHeader, icon)}
							</div>
						</div>
						{extra && <div className="extra">{extra}</div>}
					</div>
					{description && (
						<div
							className={`${
								!isMobileSize
									? 'lane-description'
									: 'lane-description-mobile'
							}`}>
							<CustomShowMoreText lines={1} text={description} />
						</div>
					)}
				</div>
			);
		} else {
			return <React.Fragment />;
		}
	};

	const getLanePrimaryHeader = (headerValue, icon) => {
		if ((!icon && !renderIcon) || isMobileSize) {
			return <span>{headerValue}</span>;
		}

		const renderFontasticIcon = () => {
			return <div className={`icon-${icon} major-header-icon-large`} />;
		};

		return (
			<div>
				{typeof renderIcon === 'function' ? (
					<div className="major-header-icon-large">
						{renderIcon()}
					</div>
				) : (
					renderFontasticIcon()
				)}
				<div className="column-spaced">
					<span className="major-header">{headerValue}</span>
				</div>
				<div className="clear" />
			</div>
		);
	};

	return (
		<div className={getClassNames()} style={style}>
			<div className="page-container">
				<div style={{ padding: '0.5rem 0' }}>
					{renderLaneHeaders()}
					{children}
					{renderLaneFooterExtra()}
				</div>
			</div>
		</div>
	);
}

export default withIsMobile(LaneContainer);
